import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromActivations from './activations.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ActivationsEffects } from './activations.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromActivations.activationsFeatureKey, fromActivations.reducer),
    EffectsModule.forFeature([ActivationsEffects]),
  ],
})
export class ActivationsStoreModule {}
